import axios from '@/modules/axiosInterceptor';
import moment from 'moment';
import { apiUrlPrefix } from '@/modules/staticData';

export default {
  mixins: [apiUrlPrefix],
  methods: {
    getDevice(deviceObj, suppressNotifications) {
      const uid = deviceObj.id;
      const deferred = new Promise((resolve, reject) => {
        axios.get(`${apiUrlPrefix}devices/${uid}`)
          .then((r) => {
            resolve(r.data.device);
          })
          .catch((r) => {
            if (!suppressNotifications) {
              const errorMessage = this.handleFormErrors(r.response.data);
              this.$root.$emit('notification-add', {
                content: `Unable to fetch the device: ${errorMessage}`,
                variant: 'danger',
                ttl: 10000,
              });
              reject(errorMessage);
            } else {
              reject();
            }
          })
          .finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    deleteDevice(deviceObj) {
      const uid = deviceObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show', {
          title: deviceObj.name,
          body: 'Delete the device permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}devices/${uid}`)
              .then(() => {
                this.$root.$emit('notification-add', { content: 'Device deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the device: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateDevice(deviceObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.put(`${apiUrlPrefix}devices`, { ...deviceObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Device updated.' });
          resolve(r.data.device);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Unable to update the device: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createDevice(deviceObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}devices`, { ...deviceObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Device created.' });
          this.$router.push({ name: 'showDevice', params: { id: r.data.device.id, deviceObj: r.data.device } });
          resolve(r.data.device);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Unable to create the device: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createCheckout(deviceObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}devices/checkout`, { ...deviceObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Devices created.' });
          this.$router.push({ name: 'devices' });
          resolve(r.data.device);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Unable to create the devices: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    downloadExcel() {
      axios.get(`${apiUrlPrefix}devices/export`, {
        responseType: 'blob',
      }).then(
        (r) => {
          const url = window.URL.createObjectURL(new Blob([r.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Devices_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`);
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        (r) => {
          this.$root.$emit('notification-add', {
            content: `Export download has failed (${r.response.data})`,
            variant: 'danger',
            ttl: 10000,
          });
        },
      );
    },
  },
};
